export const state = {
  destinations: [],
  systemDestination: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/destinations/state.js